var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "section#flower_list:before{content:\"\";background-image:url(" + escape(require("../assets/flowerlist-bg.png")) + ");position:fixed;display:block;top:0;left:0;width:100%;height:100%;background-size:cover;background-position:bottom;-webkit-transform:translateZ(0);transform:translateZ(0);will-change:transform;z-index:-1000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6c75a6a4","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/FlowerList/main.vue
// module id = 161
// module chunks = 0